module.exports = __webpack_public_path__ + "img/builder-15.33cc293c.jpg";